import styled, { keyframes } from "styled-components";

export const Container = styled.div`
  min-height: 248px;
  width: 300px;
  padding: 20px 24px;

  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0px 0px 19px -3px rgba(13, 13, 13, 0.09);

  @media(max-width: 767px) {
    width: 100%;
  }
`;

export const Title = styled.h2`
  margin-bottom: 16px;

  color: #0E1E64;
  font-family: "Platform Web";
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
`

export const Topic = styled.p`
  margin-bottom: 16px;

  opacity: 0.7;
  color: #0E1E64;
  font-family: "Platform Web";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 19px;
`

export const Separator = styled.div`
  height: 1px;
  width: 100%;
  margin-bottom: 16px;

  background: #EBEDEE;
`